/*** Javascript General ***
  http://www.hunlock.com/blogs/Ten_Javascript_Tools_Everyone_Should_Have
***/

var osHubApiKey = '0eyNfZ7Oimcj84KyWKLgSGsLQHGd3o1j';
var serviceUrl = 'https://api.os.uk/maps/raster/v1/zxy';
// EPSG:3857 or EPSG:27700. 'proj4.defs' is dependent on this, so don't swap around.
var projection = "EPSG:27700";
// Setup the EPSG:27700 (British National Grid) projection.
proj4.defs(projection, "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.9996012717 +x_0=400000 +y_0=-100000 +ellps=airy +towgs84=446.448,-125.157,542.06,0.15,0.247,0.842,-20.489 +units=m +no_defs");
ol.proj.proj4.register(proj4);
var tilegrid = new ol.tilegrid.TileGrid({
    resolutions: [896.0, 448.0, 224.0, 112.0, 56.0, 28.0, 14.0, 7.0, 3.5, 1.75, 0.875, 0.4375, 0.21875, 0.109375],
    origin: [-238375.0, 1376256.0]
});

String.prototype.htmlEntities = function () {
  return this.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\"/g, '&quot;');
};
String.prototype.stripTags = function () {
  return this.replace(/<([^>]+)>/g, '');
};
// Extend the getters so we can group the popup text with the marker.
// This breaks Heatmaps, you click on the map, get an error as the property does not exist
ol.Feature.prototype.getPopup = function(){
  return this.getProperties().popup;
};

var initialZoom = 11;
var centrePoint = new ol.proj.fromLonLat([-2.0766, 51.9014], projection);

// Must be declared at the top level and remain visible to javascript calls in HTML.
var openLayersMarkers = [];
// Make Global for future re-centre function call
var openLayersBounds;
var openStreetMap = new ol.layer.Tile({
  visible: true,
  source: new ol.source.OSM()
});

var ordSurv1 = new ol.layer.Tile({
  visible: false,
  maxZoom: 9,
  source: new ol.source.XYZ({
    url: serviceUrl + '/Leisure_27700/{z}/{x}/{y}.png?key=' + osHubApiKey,
    projection: projection,
    tileGrid: tilegrid
  })
});

var ordSurv2 =  new ol.layer.Tile({
  visible: false,
  minZoom: 9,
  source: new ol.source.XYZ({
    url: serviceUrl + '/Road_27700/{z}/{x}/{y}.png?key=' + osHubApiKey,
    projection: projection,
    tileGrid: tilegrid
  })
});

var map = new ol.Map({
  layers: [
    openStreetMap,
    ordSurv1,
    ordSurv2
  ],
  // Improve user experience by loading tiles while dragging/zooming. Will make
  // zooming choppy on mobile or slow devices.
  //loadTilesWhileInteracting: true,
  target: 'mapcanvas',
  controls: ol.control.defaults({
    attributionOptions: {
      collapsible: true
    }
  }).extend([
    new ol.control.ZoomSlider()
  ]),
  view: new ol.View({
    projection: projection,
    resolutions: tilegrid.getResolutions(),
    minZoom: 0,
    maxZoom: 19,
    center: centrePoint,
    zoom: initialZoom
  })
});

function switchMap(source) {
  switch(source) {
    case "openStreet":
      openStreetMap.setVisible(true);
      ordSurv1.setVisible(false);
      ordSurv2.setVisible(false);
      break;
    case "ordinanceSurvey":
      openStreetMap.setVisible(false);
      ordSurv1.setVisible(true);
      ordSurv2.setVisible(true);
      break;
    default:
        console.log("No map to show for '" + source + "'.");
  }
}

function closePopups() {
  $('.popover').popover('hide');
}

function openInfoBox(i) {
  for (var j = 0; j < openLayersMarkers.length; j++) {
    var element = openLayersMarkers[j].getPopup().getElement();
    // Shown if $('#' + $(element).attr('id')).next('div.popover:visible').length > 0
    // if (typeof $('#' + $(element).attr('id')).siblings()[0] === "undefined") {}
    if (i == j) {
      // Close it, and the re-open it after re-centering as the popup graphicall falls apart
//      $(element).popover('hide');
      map.getView().setCenter(openLayersMarkers[i].getGeometry().getCoordinates());
      if ($('#' + $(element).attr('id')).next('div.popover:visible').length == 0) {
        $(element).popover('show');
      }
    } else {
      $(element).popover('hide');
    }
  }
}

function centerMap() {
  map.getView().fit(
    openLayersBounds,
    {
      size:    map.getSize(),
      padding: [50, 50, 50, 50]
    }
  );
  closePopups();
}

function openTab(id) {
  var trans = $.support.transition;
  var idclp = id + "-Clp";
  window.location.hash = id;
  // Disable transitions briefly, so the divs are in their new position
  // before scrolling the page to the tag, and because the transitions
  // will not be seen anyway.
  $.support.transition = false;
  // List all open tabs
  $('#detailsaccordian .collapse.in').each(function() {
    // if the tab is not the one I want, close it
    if (this.id != idclp) {
      $('#' + this.id).collapse("hide");
    }
  });
  // Open the tab I did want - might have been left open above.
  $('#' + idclp).collapse('show');
  // Put transitions back to their original state.
  $.support.transition = trans;
  if (typeof $('#' + idclp).offset() !== "undefined") {
    $("html, body").animate(
      {
        scrollTop: $('#' + idclp).offset().top - 200
      },
      1000
    );
   }
  return true;
}

function initOpenLayers(towers) {

  var markerLayer = new ol.source.Vector();

  var bellIcons = [];
  for(i = 0; i <= 12; i++) {
    switch (i) {
      case 0:
      case 1:
      case 2:
      case 7:
      case 9:
      case 11:
        bellIcons[i] = new ol.style.Style({
          image: new ol.style.Icon(({
            anchor: [0.5, 0.5],
            anchorXUnits: 'fraction',
            anchorYUnits: 'fraction',
            src: './graphics/bellx.gif'
          }))
        });
        break;
      default:
        bellIcons[i] = new ol.style.Style({
          image: new ol.style.Icon(({
            anchor: [0.5, 0.5],
            anchorXUnits: 'fraction',
            anchorYUnits: 'fraction',
            src: "./graphics/bell" + i + ".gif"
          }))
        });
    }
  }

  var popupDefaults = {
    placement: 'top',
    html: true,
    delay: {
      show: 100,
      hide: 100
    }
  };

  // Add locations
  var nextMarker = 0;
  openLayersBounds = new ol.extent.createEmpty();
  // Perform actions for each tower
  for (var i = 0; i < towers.length; i++) {

    var popupId = towers[i].getAttribute("ref");
    var infoBox = "";
    var photo = towers[i].getElementsByTagName("photo")[0];
    if (photo !== null) {
      var thumb = photo.getElementsByTagName("thumbnail")[0];
      /* var full = photo.getElementsByTagName("fullsize")[0]; */
      infoBox += '<img class="shadow center" align="top" src="' + thumb.firstChild.nodeValue + '" alt="Taken by ' + photo.getElementsByTagName("photographer")[0].firstChild.nodeValue.stripTags() + '" border="0"';
      // Specification of the image height parameter prevents poor layout in Google popups
      // on the first click when the image dimensions are still unknown
      if (thumb.getAttribute("height")) {
        infoBox += ' height="' + (parseInt(thumb.getAttribute("height")) / 2 + 10) + '"';
      }
      if (thumb.getAttribute("width")) {
        infoBox += ' width="' + (parseInt(thumb.getAttribute("width")) / 2 + 10) + '"';
      }
      infoBox += '>';
    }
    infoBox += '<p class="plain">' + towers[i].getAttribute("dedication");
    infoBox += "<br>" + towers[i].getAttribute("bells") + ", " + towers[i].getAttribute("weight") + ", " + towers[i].getAttribute("osgrid") + "</p>";
    infoBox += '<p class="small" style="text-align:left;">';
    infoBox += '<a onclick="javascript:openTab(\'' + towers[i].getAttribute("ref") + '\')" href="#' + towers[i].getAttribute("ref") + '">More&hellip;</a>';
    infoBox += '</p>';

    jQuery(
      '<div/>',
      {id: popupId}
    ).appendTo('#map');
    $('#' + popupId).popover(
      jQuery.extend(
        {
          title: towers[i].getAttribute("town") + '<span class="close">&times;</span>',
          content: infoBox
        },
        popupDefaults
      )
    ).on('shown.bs.popover', function() {
      // Popover for the quick search additional fields
      var item = $(this);
      item.parent().find('.popover .close').click(function() {
        item.popover('hide');
      });
    });

    var point = new ol.proj.fromLonLat(
      [
        parseFloat(towers[i].getAttribute("longitude")),
        parseFloat(towers[i].getAttribute("latitude"))
      ],
    projection);
    ol.extent.extend(
      openLayersBounds,
      ol.extent.boundingExtent([
        point
      ])
    );
    var popup = new ol.Overlay({
      element: $('#' + popupId)[0],
      position: point
    });
    var marker = new ol.Feature({
      geometry: new ol.geom.Point(point),
      name: towers[i].getAttribute("dedication") + ", " + towers[i].getAttribute("town"),
      popup: popup
    });
    marker.setStyle(bellIcons[parseInt(towers[i].getAttribute("bells"))]);
    markerLayer.addFeature(marker);
    map.addOverlay(popup);

    openLayersMarkers[nextMarker] = marker;
    nextMarker++;
  }

  map.addLayer(
    new ol.layer.Vector({
      source: markerLayer
    })
  );

  // display popup on click
  map.on('click', function(evt) {
    var feature = map.forEachFeatureAtPixel(
      evt.pixel,
      function(feature) {
        return feature;
      }
    );
    // Affect all but the feature clicked
    markerLayer.getFeatures().forEach(function(f) {
      if (f != feature) {
        $(f.getPopup().getElement()).popover('hide');
      }
    });
    if (feature) {
      // Need to test if we click the heatmap element or the icon.
      // 'feature.getPopup().getElement()' is equivalent to ID of the marker e.g.'#something'
      var element = feature.getPopup();
      if (element !== undefined) {
        $(element.getElement()).popover('toggle');
      }
    }
  });
}

// Call this function when the page has been loaded
function initialize() {
  // Read in towers from an XML definition file.
  downloadUrl("towers.xml", function(data) {
    var towers = data.documentElement.getElementsByTagName("tower");
    initOpenLayers(towers);
    centerMap();
  });

  // If the URL has a #id of a tower, need to open the collapsed div.
  if (window.location.hash.length > 0) {
    var item = window.location.hash.substring(window.location.hash.indexOf("#") + 1);
    // Open the tab anyway, even if 'item' is not a tower
    openTab(item);
  }
}

$(document).ready(function() {
  initialize();
});
